import React, { useEffect, useRef, useState } from "react";
import Search from "../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker, Form, Progress, Select, Table } from "antd";
import svg15 from "../../../../assets/svg/svg15.svg";
import CardLoading from "../../../../components/CardLoading";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import { setActiveObj } from "../../../../features/obj/objSlice";
import {
  cashConverter,
  dateForHumans,
  extractYear,
  formatText,
} from "../../../../utils";
import moment from "moment";
import { projStatusData } from "../../../../data";
import BreadCrumb from "../../../../layout/BreadCrumb";

function CommAssociatedProjectsTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { pathname } = useLocation();
  const url = "main_project/fetch_mainprojects";

  const { loading, data, count, activeObjSchemes } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    activeObjSchemes: state.obj.activeObj["communitySchemes"],
  }));

  const { refetchKey } = useSelector((state) => state.global);

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const [selectId, setSelectId] = useState("ONGOING");
  const [yearData, setYearData] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        projectSchemeId: activeObjSchemes?.schId,
        projectStartDate: extractYear(yearData),
        projectYear: null,
        projectStatus: selectId,
        projectName: e.target.value == "" ? null : e.target.value,
        irrigationPathWayIrrigationPathwayId: null,
      })
    );
  };

  const handleView = async (item) => {
    await dispatch(
      setActiveObj({
        key: selectId === "PLANNED" ? "plannedProject" : "ongoingProject",
        data: item,
      })
    );
    await navigate(
      selectId === "PLANNED" ? "planned-pipeline-details" : "/project-view"
    );
  };
  const handleViewName = async (item) => {
    await dispatch(
      setActiveObj({
        key: selectId === "PLANNED" ? "plannedProject" : "ongoingProject",
        data: item,
      })
    );
    await navigate(
      selectId === "PLANNED" ? "planned-pipeline-details" : "/project-view"
    );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Project Name",
      width: "300px",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.projectName}
          </div>
        );
      },
      sorter: (a, b) => a.projectName.localeCompare(b.projectName),
    },
    {
      title: "Number",
      dataIndex: "projectNumber",
      sorter: (a, b) => a.projectNumber.localeCompare(b.projectNumber),
    },
    {
      title: "Type",
      dataIndex: "projectTypeName",
      sorter: (a, b) => a.projectTypeName.localeCompare(b.projectTypeName),
    },
    {
      title: "Implementing Agency",
      dataIndex: "projectAgencyName",
      sorter: (a, b) => a.projectAgencyName.localeCompare(b.projectAgencyName),
    },
    {
      title: "Targeted Area",
      dataIndex: "projectAreaTarget",
      sorter: (a, b) => a.projectAreaTarget.localeCompare(b.projectAreaTarget),
    },

    {
      title: "Project Cost",
      dataIndex: "projectCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.projectCost.localeCompare(b.projectCost),
    },
    {
      title: "Start Date",
      dataIndex: "projectStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.projectStartDate).valueOf() -
        moment(b.projectStartDate).valueOf(),
    },
    {
      title: "Status",
      dataIndex: "projectStatus",
      render: (item) => {
        const colors = {
          ONGOING: "#7DACDC",
          PLANNED: "#E5E7E9",
          COMPLETED: "#B1E17C",
        };
 
 
        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <button onClick={() => handleView(item)}>
            <img src={svg15} alt="svg15" />
          </button>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        projectSchemeId: activeObjSchemes?.schId,
        projectStartDate: extractYear(yearData),
        projectYear: null,
        projectStatus: selectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        irrigationPathWayIrrigationPathwayId: null,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, [selectId, yearData]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <>
      {" "}
      <BreadCrumb
        breadcrumbs={[ 
          { title: "Schemes Overview", path: "/scheme/scheme-overview" },
          { title: "Community", path: "/scheme/community-scheme" },
          { title: "Community View", path: "/scheme/community-scheme-view" },
          { title: `Associated Projects for ${activeObjSchemes?.schName}` },
        ]}
      />
      <div className="lg:min-h-[88vh] flex flex-col mt-[1.25rem]">
        <div className="flex flex-col w-full  flex-1  white_card">
          <div className="form-add-h !text-[#050505] mt-[.63rem]">
            Schemes Associated Projects
          </div>
          <div className="proj_desc mt-[1rem]">
            {activeObjSchemes?.schName} • Date:{" "}
            {dateForHumans(activeObjSchemes?.schConstructionStartDate)}
          </div>
          <div className="flex items-center justify-between mt-[2.5rem]">
            <div className="lg:w-[29.1875rem] w-auto">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text={"Search ..."}
              />
            </div>
            <Form
              layout="vertical"
              ref={formRef}
              name="control-ref"
              className="w-full lg:w-[30%]"
              form={form}
            >
              <div className="flex items-center gap-x-[1.25rem]">
                <DatePicker
                  placeholder="Year"
                  className="input !w-[31.1rem]"
                  picker="year"
                  value={yearData}
                  onChange={(value) => setYearData(value)}
                />

                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    projStatusData?.length > 0 &&
                    projStatusData?.map((item) => ({
                      value: item?.value,
                      label: item?.label,
                    }))
                  }
                  value={selectId}
                  onChange={(value) => setSelectId(value)}
                  placeholder="Select"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </div>
            </Form>
          </div>

          <div className="max-w-full w-full overflow-x-auto">
            <Table
              rowSelection={false}
              className="mt-[1.75rem] w-full"
              scroll={{
                x: "max-content",
              }}
              rowKey={(record) => record?.projectId}
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={{
                position: ["bottomRight"],
                current: pageIndex + 1,
                total: count,
                pageSize: pageSize,
                onChange: (page, size) => {
                  setPageIndex(page - 1);
                  setPageSize(size);
                  fetchTableData(page - 1, size);
                },
                showSizeChanger: false,
                hideOnSinglePage: true,
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default CommAssociatedProjectsTable;
